import axios from "axios";
import { GET_TOKEN_FAIL, GET_TOKEN_REQUEST, GET_TOKEN_SUCCESS } from "../constant";

export const GetToken = () => {
    return async (dispatch) => {
        dispatch({ type: GET_TOKEN_REQUEST });
        let options = {
            method: 'GET',
            url: `${process.env.REACT_APP_API_URL}/auth/getPubTokenClient`,
            headers: {
                'Accept': 'application/json',
            },
        };
        await axios(options)
            .then(res => {
                dispatch({ type: GET_TOKEN_SUCCESS, payload: res?.data });
                localStorage.setItem("customer_token", res?.data?.token)
            })
            .catch(err => {
                console.error("GET TOKEN ERROR", err)
                dispatch({ type: GET_TOKEN_FAIL });
            })
    }
}